import { useEffect, useState } from 'react';
import api from '../api/api';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Dashboard() {
  const [interruptions, setInterruptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/login');
    api.get('/interruptions').then((res) => setInterruptions(res.data));
  }, [navigate]);

  return (
    <>
      <Header />
      <main className="container">
        <h2>Interruptions</h2>
        <Link to="/add" className="add-btn">
          + Ajouter une interruption
        </Link>
        <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Application</th>
              <th>Nature</th>
              <th>Début</th>
              <th>Fin</th>
              <th>Commentaire</th>
            </tr>
          </thead>
          <tbody>
            {interruptions.map((i) => (
              <tr key={i.id}>
                <td>{i.application_nom}</td>
                <td>{i.nature}</td>
                <td>{new Date(i.date_debut).toLocaleString()}</td>
                <td>
                  {i.date_fin ? new Date(i.date_fin).toLocaleString() : '-'}
                </td>
                <td>{i.commentaire}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </main>
      <Footer />
    </>
  );
}
